<script setup lang="ts">
import { RouteNames } from '~~/server/enums';

defineNuxtRouteMiddleware(() => {
  return navigateTo(RouteNames.PREDICTION);
});
</script>

<template>
  <div></div>
</template>